import PERMISSIONS from '../enum';
const taskAccess = {
  create: [PERMISSIONS.TASK.WRITE, PERMISSIONS.QUESTION.SCHEDULE],
  write: [PERMISSIONS.TASK.WRITE, PERMISSIONS.QUESTION.SCHEDULE],
  view: [PERMISSIONS.TASK.VIEW, PERMISSIONS.QUESTION.SCHEDULE],
  delete: [PERMISSIONS.TASK.DELETE, PERMISSIONS.QUESTION.SCHEDULE],
};

export default taskAccess;
